module.exports = __webpack_public_path__ + "static/img/bjyz_jkfa_icon.png";